


export class NotaFiscalAniel {
  "purchasingDocumentCategory";
  "purchasingDocument";
  "vendorNumber";
  "purchasingDocumentDate";
  "purchasingDocumentItemNumber";
  "purchasingDocumentDeletionIndicator";
  "materialNumber";
  "storageLocation";
  "purchaseOrderQuantity";
  "orderUnit";
  "netPrice";
  "materialDocumentNumber";
  "movementType";
  "postingDate";
  "quantity";
  "referenceDocumentNumber";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `NotaFiscalAniel`.
   */
  static getModelName() {
    return "NotaFiscalAniel";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of NotaFiscalAniel for dynamic purposes.
  **/
  static factory(data) {
    return new NotaFiscalAniel(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'NotaFiscalAniel',
      plural: 'NotaFiscalAniels',
      path: 'NotaFiscalAniels',
      properties: {
        "purchasingDocumentCategory": {
          name: 'purchasingDocumentCategory',
          type: 'string'
        },
        "purchasingDocument": {
          name: 'purchasingDocument',
          type: 'string'
        },
        "vendorNumber": {
          name: 'vendorNumber',
          type: 'string'
        },
        "purchasingDocumentDate": {
          name: 'purchasingDocumentDate',
          type: 'Date'
        },
        "purchasingDocumentItemNumber": {
          name: 'purchasingDocumentItemNumber',
          type: 'number'
        },
        "purchasingDocumentDeletionIndicator": {
          name: 'purchasingDocumentDeletionIndicator',
          type: 'string'
        },
        "materialNumber": {
          name: 'materialNumber',
          type: 'string'
        },
        "storageLocation": {
          name: 'storageLocation',
          type: 'string'
        },
        "purchaseOrderQuantity": {
          name: 'purchaseOrderQuantity',
          type: 'number'
        },
        "orderUnit": {
          name: 'orderUnit',
          type: 'string'
        },
        "netPrice": {
          name: 'netPrice',
          type: 'number'
        },
        "materialDocumentNumber": {
          name: 'materialDocumentNumber',
          type: 'string'
        },
        "movementType": {
          name: 'movementType',
          type: 'string'
        },
        "postingDate": {
          name: 'postingDate',
          type: 'Date'
        },
        "quantity": {
          name: 'quantity',
          type: 'number'
        },
        "referenceDocumentNumber": {
          name: 'referenceDocumentNumber',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/NotaFiscalAniel.js